import styled from 'styled-components';

import { Translate } from '@dreryk/react-common';
import { basicHeaderTextStyle } from '@dreryk/react-components';

import { medicalDevicesTranslationKeys } from './translations';

const StyledMedicalDevicesPanelHeader = styled.span`
   ${basicHeaderTextStyle}
`;
StyledMedicalDevicesPanelHeader.displayName = 'StyledMedicalDevicesPanelHeader';

export const MedicalDevicesPanelHeader = (): JSX.Element => (
   <StyledMedicalDevicesPanelHeader>
      <Translate>{medicalDevicesTranslationKeys.medicalDevicesSupplyOrder}</Translate>
   </StyledMedicalDevicesPanelHeader>
);
